import Section from './section.js';
export default Section;